import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ErrorStateService {
  private errorSubject = new BehaviorSubject<string>('');
  error$ = this.errorSubject.asObservable();
  timeout: any;
  
  constructor() {
    this.errors = [];
  }

  public errors: string[];

  public hasErrors(): boolean {
    return this.errors && this.errors.length > 0;
  }

  public addError(error: string) {
    this.errors.push(error);
  }

  public clearErrors() {
    this.errors = [];
  }

  setError(error: string) {

    if( !this.isEmpty ){
      clearTimeout(this.timeout);
    }

    this.errorSubject.next(error);
    return {
      // clear the error after a certain amount of time, default is 3 seconds
      clearAfter: (timeout: number = 3000) => {
        if( this.timeout ){
          clearTimeout(this.timeout);
        }
        this.timeout = setTimeout(() => {
          this.clear();
        }, timeout);
      }
    }
  }

  clear(): void{
    this.errorSubject.next('');
  }

  get isEmpty(): boolean {
    return this.errorSubject.getValue() === '';
  }


}
